import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="gsf-section" data-testid="not-found">
            <div className="gsf-container text-center py-24">
                <div className="gsf-eyebrow">404 · Not found</div>
                <h1 className="mt-4 font-serif text-5xl text-[color:var(--gsf-green-700)] font-bold">Page not found</h1>
                <p className="mt-4 text-[color:var(--gsf-body)]">The page you were looking for could not be found.</p>
                <Link to="/" className="mt-8 gsf-btn-primary inline-flex" data-testid="404-home">Return home</Link>
            </div>
        </section>
    );
}
